import { call, put, select, takeLatest } from "redux-saga/effects";
import qs from 'qs';
import { FETCH_MEETING_PREP_PROMPTERS_CARD_REQUEST, fetchMeetingPrepPromptersCardFailure, fetchMeetingPrepPromptersCardSuccess } from "../../actions/meetingPrep/promptersCardActions";
import iq_api_v2 from "../../../../services/iqApiV2";

async function findMeetingPrepPromptersCardData(opportunityId="") {
    const data = qs.stringify({
      opportunity_id: opportunityId
    });
  
    // console.log("data",data)
    try {
      const response = await iq_api_v2.post("/opportunities/get_value_selling_prompter_2", {
        opportunity_id: opportunityId
      }, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // console.log('Response:', response.data);
      return response?.data
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
function* fetchMeetingPrepPromptersCardSaga() {
  try {
    const payload = yield select(
      (state) => state?.meetingPrepPromptersCardReducer?.payload
    );
    const { opportunityId=""} = payload;
    const data = yield call(
        findMeetingPrepPromptersCardData,
        opportunityId
    );
    yield put(fetchMeetingPrepPromptersCardSuccess(data));
  } catch (error) {
    yield put(fetchMeetingPrepPromptersCardFailure(error.message));
  }
}

// Watcher Saga
export function* watchMeetingPrepPromptersCardData() {
  yield takeLatest(FETCH_MEETING_PREP_PROMPTERS_CARD_REQUEST, fetchMeetingPrepPromptersCardSaga);
}
